import { buildPage } from '@/tools/tracking/utils';

function buildTarget(pageType: string): {
  id: string;
  type: string;
  pageType: string;
} {
  return {
    id: pageType,
    type: 'Page',
    pageType,
  };
}

function buildRadiusSearchInitiateEvent({ label }: { label: string }): {
  type: 'Click';
  intent: 'Open';
  object: {
    id: string;
    name: string;
    type: string;
    action: string;
    elementType: string;
    label: string;
    position: string;
    size: string;
  };
  page: { '@id': string; '@type': string; pageType: string };
  target: { id: string; type: string; pageType: string };
} {
  return {
    type: 'Click',
    intent: 'Open',
    object: {
      type: 'UIElement',
      id: 'radiussearch:element:open',
      name: 'GeoSearchOpen',
      action: 'Click UIElement',
      elementType: 'Button',
      label,
      position: 'Filter bar',
      size: 'medium',
    },
    page: buildPage('listing'),
    target: buildTarget('listing'),
  };
}

function buildRadiusSearchCancelEvent(): {
  type: 'Click';
  intent: 'Close';
  object: {
    id: string;
    type: string;
    action: string;
    elementType: string;
    label: string;
    position: string;
  };
  page: { '@id': string; '@type': string; pageType: string };
  target: { id: string; type: string; pageType: string };
} {
  return {
    type: 'Click',
    intent: 'Close',
    object: {
      id: 'radiussearch:element:dismiss',
      type: 'UIElement',
      action: 'Click UIElement',
      elementType: 'Button',
      label: 'X',
      position: 'Top',
    },
    page: buildPage('listing'),
    target: buildTarget('listing'),
  };
}

export { buildRadiusSearchInitiateEvent, buildRadiusSearchCancelEvent };
